import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Paragraph, Heading1, Heading2, LinkStyled,
} from '../../components/typography';
import PageLink from '../../components/PageLink';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Alkohol" activeSidemenu="Oel">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Køb øl online</Heading1>
          <Paragraph>
            Køb øl online hos Skafte og vælg dine favoritter blandt vores enorme udvalg af både dåse- og flaskeøl. Vi fører desuden også alkoholfri øl, alkoholsodavand og cider samt vin. Bestil øl online og få hurtig levering, hvad enten det er til foreninger, virksomheder eller private. Husk, at vi også tilbyder et væld af forskellige varianter af <LinkStyled to="/fadoel">fadøl</LinkStyled> til din næste fest eller arrangement.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <RowProductView>
        <PageLink
          title="Dåseøl"
          link="/oel/daaseoel"
          image1="produkter-oelvand.groen-tuborg-daase.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  &nbsp;
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Flaskeøl"
          link="/oel/flaskeoel"
          image1="produkter-oelvand.groen-tuborg-flaske.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          image2="produkter-oelvand.tuborg-classic-flaske.png"
          image2Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  &nbsp;
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Alkoholfri Øl"
          link="/oel/alkoholfri-oel"
          image1="produkter-oelvand.carlsberg-nordic-flaske.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          image2="produkter-oelvand.vestfyn-light-flaske.png"
          image2Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  &nbsp;
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Vin"
          link="/vin"
          image1="produkter-oelvand.2852-kasse.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  &nbsp;
                </Paragraph>
              </React.Fragment>
            )
          }
        />
        <PageLink
          title="Alkoholsodavand"
          link="/alkoholsodavand"
          image1="produkter-oelvand.2810-flaske.png"
          image1Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          image2="produkter-oelvand.2930-flaske.png"
          image2Size={['140px', '100px', '130px', '120px', '100px', '100px']}
          paragraph={
            (
              <React.Fragment>
                <Paragraph>
                  &nbsp;
                </Paragraph>
              </React.Fragment>
            )
          }
        />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Køb øl online og spar både tid og penge</Heading2>
          <Paragraph>
            Det er nemt og hurtigt at købe øl online - og så sparer du endda samtidig penge. Det eneste du skal gøre er at vælge din foretrukne variant og lægge den i kurven. Så snart din bestilling er lagt, sørger vi for lynhurtig levering, så du kan sidde med din favorit øl i hånden og nyde den kolde, læskende følelse.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Køb øl online lokalt og med god samvittighed</Heading2>
          <Paragraph>
            Hvis du er typen, der godt kan lide at købe stort ind, når du handler øl, så er der god grund til at købe hos en dansk webshop, modsat at køre en tur til Tyskland. Vi har nemlig pant på både flaske- og dåseøl pr. dansk lovkrav, hvilket betyder, at du med god samvittighed kan bestille øl online hos os med god samvittighed - også i større mængder. Der tages nemlig hensyn til miljøet med pantmærket, men også fordi du sparer den lange køretur blot for at få en skarp pris.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Nyd godt af et kæmpe udvalg, når du køber øl online</Heading2>
          <Paragraph>
            Når du tager et kig på vores webshop, vil du opleve, at vi går meget op i at føre præcis det du ønsker og har lyst til. Nogen sværger til øl på flaske og mener, at det er den eneste måde at nyde en øl på, mens andre sværger til øl på dåse. Derfor finder du naturligvis begge varianter, så du kan finde netop den øl, du synes bedst om. Køb øl online hos Skafte og vælg mellem de klassiske Tuborg og Carlsberg, men også et væld af specialøl på både flaske og dåse.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Bestil øl online: flaskeøl</Heading2>
          <Paragraph>
            Vores sortiment byder på over 30 forskellige slags øl på flaske, og du finder både de helt klassiske og almindelige varianter, som vi alle holder af, men du finder desuden også et hav af forskellige pilsnere. Du kan bl.a. gå ombord i Rød Tuborg, Thy Øko Pilsner, KB Hvidtøl og mange, mange flere af de gamle og kendte klassikere på flaske.
          </Paragraph>
          <Paragraph>
            Hvis du er mere til specialøl, så kan du også købe øl online fra producenter som Jacobsen, Tiger Beer, Hoegaarden, Leffe, Grimbergen og Kronenbourg.
          </Paragraph>
          <Paragraph>
            Bestil øl online op mod juletid og få fingrene i de velsmagende julevarianter, der udelukkende er på markedet denne årstid.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Bestil øl online: dåseøl</Heading2>
          <Paragraph>
            Du kan også let købe øl online, hvis du er mere til øl på dåse - eller bare godt kan lide muligheden for at kunne stable rammerne uden at de optager alt for meget plads. Vi forhandler alle de populære varianter, herunder den velkendte Tuborg Classic, Grøn Tuborg og Carlsberg, men også Carl’s Special og Carlsberg 1883.
          </Paragraph>
          <Paragraph>
            Uanset hvilken variant du er mest til, kan du købe øl online hos Skafte - vi sørger for hurtig levering. Nemt og bekvemt.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
